import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import BasicInformation from './BasicInformation';
import CSUEID from './CSUEID';
import TranscriptStatus from './TranscriptStatus';
import TranscriptAddress from './TranscriptAddress';
import PermissionSplash from 'components/PermissionSplash';

export default class Academic extends React.Component {
	render() {
		let routeProps = this.props;
		const read = this.props.userRole !== undefined ? this.props.userRole.some(role => {
			return (role.section === 'Academic' && role.access_read === "1")
		}) : false
	if ((this.props.variant === 'admin' && read === true) || this.props.variant !== 'admin') {
			return (
				<Switch>
					<Route path="/portal/academic/CSU EID" component={CSUEID} />
					<Route path="/portal/academic/Basic Information" render={() => <BasicInformation {...routeProps} />} />
					<Route path="/portal/academic/Updated Transcript Status" render={() => <TranscriptStatus {...routeProps} />} />
					<Route path="/portal/academic/Transcript Address" render={() => <TranscriptAddress {...routeProps} />} />
					<Route path="*" render={() =>
						<Redirect to="/portal/academic/CSU EID" />
					} />
				</Switch>
			);
		} else {
			return (

				<PermissionSplash />

			);
		}
	}
}


// WEBPACK FOOTER //
// ./portal-components/Portal/Academic/index.jsx